import { render, staticRenderFns } from "./RtQuote.vue?vue&type=template&id=2e540aff&scoped=true&"
import script from "./RtQuote.vue?vue&type=script&lang=js&"
export * from "./RtQuote.vue?vue&type=script&lang=js&"
import style0 from "./RtQuote.vue?vue&type=style&index=0&id=2e540aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e540aff",
  null
  
)

export default component.exports